

    <tabset #tablistcomp>
        <tab >
            <ng-template tabHeading>
                <i class="fas fa-list"></i> Flight List
              </ng-template>
            <app-flight-list #flightlist [supervision]="supervision" (flightSelectedEvent)="flightSelectedEventHandler($event)"></app-flight-list>
        </tab>
        <tab *ngFor="let tabz of tabList"
            [active]="tabz.active"
            (select)="tabz.active = true"
            (deselect)="tabz.active = false"
            [disabled]="tabz.disabled"
            [removable]="tabz.removable"
            (removed)="removeTabHandler(tabz)"
            [customClass]="tabz.customClass">
            <div [ngSwitch]="tabz?.content">
                <ng-template tabHeading>
                    <i class="fas fa-dice-d6"></i> {{tabz.flight.name}}
                  </ng-template>
            <app-flight-files [flight]="tabz.flight" [supervision]="supervision"></app-flight-files>

        </div>
        </tab>
    </tabset>    


